export default __webpack_public_path__ + "images/msaserversigninlottie_3_e330977d6076752f3f36f5adf5474056.json";